import React from 'react'
import { ReactComponent } from './settings.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface SettingsProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', SettingsProps>

export const SettingsIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
